<template>
  <basic-container>
    <Search />
    <Table />
  </basic-container>
</template>

<script>
import { getProtocolNameFromDict, getProtocolReceiveType, getProtocolSendType, getProtocolUpdateList } from '@/api/protocolCompliance/protocolUpdate';
import { observable } from "vue";
import Search from './components/search.vue';
import Table from './components/table.vue';
export default {
  name: 'WebSaaSIndex',
  components: {
    Search,
    Table
  },
  provide() {
    return {
      /** 搜索参数 */
      searchParams: this.searchParams,
      /** 协议数组 */
      protocolList: this.protocolList,
      /** 列表数据 */
      list: this.list,
      /** 分页的方法 */
      loadList: this.loadList,
      /** 发端类型 */
      sendPlatform: this.sendPlatform,
      /** 收端类型 */
      receivePlatform: this.receivePlatform,
    };
  },
  data() {
    return {
      /** 协议数组 */
      protocolList: observable({
        value: []
      }),
      searchParams: observable({
        /** 协议名称 */
        agreementName: '',
        current: 1,
        size: 10,
        total: 1,
      }),
      list: observable({
        value: [],
      }),
      /** 收端类型 */
      receivePlatform: observable({
        value: []
      }),
      /** 发端类型 */
      sendPlatform: observable({
        value: []
      }),
    };
  },
  async created() {
    await this.getSendType()
    await this.getReceiveType()
    await this.getProtocolName()
    await this.loadList()
  },
  methods: {
    /** 分页的接口 */
    async loadList() {
      const { data } = await getProtocolUpdateList(this.searchParams)
      console.log('协议升级策略分页接口的响应', data);
      this.list.value = data.data.records.map((item) => {
        return {
          ...item,
          senderPlatforms: item.senderPlatforms.map((senderPlatform) => {
            const minV = senderPlatform.minClientVersion || ''
            const maxV = senderPlatform.maxClientVersion
            return this.getLabel(senderPlatform.platformType, this.sendPlatform.value) + ` [${minV} - ${maxV}]`
          }).join(','),
          receiverPlatforms: item.receiverPlatforms.map((receiverPlatform) => {
            const minV = receiverPlatform.minClientVersion || ''
            const maxV = receiverPlatform.maxClientVersion
            return this.getLabel(receiverPlatform.platformType, this.receivePlatform.value) + ` [${minV} - ${maxV}]`
          }).join(',')
        }
      })
      this.searchParams.total = data.data.total
    },

    /** 获取业务字典中-协议名称的接口 */
    async getProtocolName() {
      const { data } = await getProtocolNameFromDict()
      console.log('业务字典中-协议名称的接口', data);
      this.protocolList.value = data.data.map(item => ({
        name: item.dictValue,
        code: item.dictKey
      }))
    },
    /** 根据value返回对应的label值 */
    getLabel(value, ary) {
      const res = ary.find(item => item.value == value);
      return res ? res.label : "";
    },

    //^ ^--------------数据初始化-------------^ ^
    /** 获取系统字典中发端类型 */
    async getSendType() {
      const { data } = await getProtocolSendType();
      this.sendPlatform.value = data.data.map(item => {
        return {
          label: item.dictValue || '',
          value: Number(item.dictKey) || ''
        };
      });
    },
    /** 获取系统字典中收端类型 */
    async getReceiveType() {
      const { data } = await getProtocolReceiveType();
      this.receivePlatform.value = data.data.map(item => {
        return {
          label: item.dictValue || '',
          value: Number(item.dictKey) || ''
        };
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
